import React from 'react';
import { FormControl, Button, Box } from '@mui/material';
import PropTypes from 'prop-types';
import M from 'messages';
import classes from './styles';

const SimpleMultiSelectButtonsGroup = ({
  name,
  options = [],
  values = [],
  handleChange,
  disabled = false,
  noTranslation = false,
  size = 'medium',
}) => {
  const handleClick = option => {
    const isSelected = values.includes(option);
    const newValues = isSelected ? values.filter(v => v !== option) : [...values, option];

    handleChange(name, newValues, option, isSelected ? 'removing' : 'adding');
  };

  const getButtonName = option => {
    if (option === 'notSet') return 'Not specified';
    return noTranslation ? toUpperCase(option) : M.get(option);
  };

  const toUpperCase = option => {
    return option.charAt(0).toUpperCase() + option.slice(1);
  };

  return (
    <FormControl component="fieldset">
      <Box className={classes.group}>
        {options.map(option => {
          const isSelected = values.includes(option);

          return (
            <Button
              key={option}
              aria-label={option}
              variant="outlined"
              sx={{
                ...classes.buttonStyle,
                ...(isSelected
                  ? disabled
                    ? classes.buttonStyle['&.disabled']
                    : classes.buttonStyle['&.selected']
                  : classes.buttonStyle['&.not-selected']),
              }}
              onClick={() => handleClick(option)}
              disabled={disabled}
              size={size}>
              {noTranslation ? getButtonName(option) : M.get(option)}
            </Button>
          );
        })}
      </Box>
    </FormControl>
  );
};

SimpleMultiSelectButtonsGroup.propTypes = {
  // name of the group (passed back in handleChange)
  name: PropTypes.string.isRequired,

  // all possible values, in the exact order you want to show them
  options: PropTypes.arrayOf(PropTypes.string).isRequired,

  // currently selected values, e.g. [] or ['following', 'rated']
  values: PropTypes.arrayOf(PropTypes.string),

  // (name, newValuesArray, clickedValue, 'adding' | 'removing')
  handleChange: PropTypes.func.isRequired,

  disabled: PropTypes.bool,
  noTranslation: PropTypes.bool,
  size: PropTypes.string,
};

export default SimpleMultiSelectButtonsGroup;
